import { PostCard } from '@/components/PostCard';
import { FlexRow, FlexCol } from '@zopauk/react-components';
import { type PostListFragment, useLatestPostsQuery } from '@/utils/dato/generated';

const PostList = ({ posts }: PostListFragment) => {
  const { data } = useLatestPostsQuery(undefined, { enabled: !posts.length });

  if (posts || data?.posts) {
    return (
      <div className="mb-8 text-left">
        <FlexRow>
          {(posts.length ? posts : data?.posts || []).map((post) => (
            <FlexCol style={{ display: 'flex' }} className="mb-4" align="stretch" key={post.id} l={4}>
              <PostCard featured={post.featured || false} data={post} />
            </FlexCol>
          ))}
        </FlexRow>
      </div>
    );
  }

  return null;
};

export default PostList;
